import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { homeClothChangeModalSelector } from 'core/store/reducers/homeReducer/HomeSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const ClothChangeModal = lazy(() => import('./ClothChangeModal'));

function LazyClothChangeModal() {
	const isModalOpen = useSelector(homeClothChangeModalSelector);

	return (
		<LazyRenderLayer isShown={isModalOpen}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<ClothChangeModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyClothChangeModal;
